/** Per-stage external URLs, overridable at build time. */
export const DASHBOARD_URL =
  import.meta.env.VITE_DASHBOARD_URL ?? 'https://dashboard.vocalcord.io';

/**
 * Deep link that signs the user in (channel login) and then drops them
 * straight into the Stripe checkout flow — see the dashboard's
 * `?upgrade=1` handling.
 */
export const DASHBOARD_UPGRADE_URL = `${DASHBOARD_URL}/?upgrade=1`;
